import GoogleMap from "../utils/map";
const Contacts = {
  init() {
    Contacts.renderMap();
    Contacts.copyProps();
  },

  renderMap() {
    const mapEl = $("#contact-map");

    if (!mapEl.length) {
      return;
    }

    const data = {
      lat: 56.9070943,
      lng: 24.2549061,
      zoom: 10,
    };

    GoogleMap.create(data, mapEl);
  },

  copyProps() {
    //Copy one property to clipboard
    $(".properties-list__item").on("click", function () {
      var oneProperty = $(this).find(".properties-list__item-value span").text().trim();
      copyText(oneProperty);

      const toggleNotice = () => { $(this).find(".notice").toggleClass("hidden"); }
      toggleNotice();
      setTimeout(toggleNotice, 1500);
    });

    //Copy all properties to clipboard
    $(".properties-list__copy-all").on("click", function () {
      var allProperties = '';
      $('.properties-list').find(".properties-list__item-name, .properties-list__item-value span").each(function () {
        allProperties += $(this).text().trim() + '\n';
      });
      copyText(allProperties);

      const toggleNotice = () => { $(this).find(".notice").toggleClass("hidden"); }
      toggleNotice();
      setTimeout(toggleNotice, 1500);
    });

    //Copy property URL to clipboard
    $(".properties-list__copy-link").on("click", function () {
      let url = $(this).data('url');
      copyText(url);

      const toggleNotice = () => { $(this).find(".notice").toggleClass("hidden"); }
      toggleNotice();
      setTimeout(toggleNotice, 1500);
    });

    /**
     * Copy text to clipboard
     */
    function copyText(text) {
      const input = document.createElement("textarea");
      input.value = text;
      document.body.appendChild(input);
      input.select();
      document.execCommand("copy");
      document.body.removeChild(input);
    }
  },
};

export default Contacts;
